// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-layout {
  display: flex;
  min-height: 100vh;
  position: relative;
  width: 100%;
}

.main-content {
  flex: 1 1;
  /* padding: 2rem; */
  margin-left: 117px;
  width: calc(100% - 117px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: rgba(215, 217, 217, 0.25);
}

.main-content.sidebar-collapsed {
  margin-left: 80px;
  width: calc(100% - 80px);
}`, "",{"version":3,"sources":["webpack://./src/Layout/MainLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B","sourcesContent":[".app-layout {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.main-content {\r\n  flex: 1;\r\n  /* padding: 2rem; */\r\n  margin-left: 117px;\r\n  width: calc(100% - 117px);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  background-color: rgba(215, 217, 217, 0.25);\r\n}\r\n\r\n.main-content.sidebar-collapsed {\r\n  margin-left: 80px;\r\n  width: calc(100% - 80px);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
